import { render } from "./ServiceFeeCard.vue?vue&type=template&id=0225cdc8&scoped=true"
import script from "./ServiceFeeCard.vue?vue&type=script&lang=js"
export * from "./ServiceFeeCard.vue?vue&type=script&lang=js"

import "./ServiceFeeCard.vue?vue&type=style&index=0&id=0225cdc8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225cdc8"]])

export default __exports__